import React from 'react'
import { NumberConvert } from '../../../common/numberConvert'

const DeliveryCount = ({ store, data }) => {
  return (
    <div className='bg-stone-600/60 flex flex-col gap-3 rounded-md p-5 duration-150'>

      <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
        <p>{`${store} 택배/퀵 현황`}</p>
      </div>

      <div className='flex justify-between'>
        <div>
          <p>택배 처리</p>
          <p>퀵 처리</p>
        </div>

        <div>
          <p className='tracking-wider'>{`${NumberConvert(Number(data.data0))} 건`}</p>
          <p className='tracking-wider'>{`${NumberConvert(Number(data.data1))} 건`}</p>
        </div>
      </div>

    </div>
  )
}

export default DeliveryCount